import { WidgetInstance, getData } from '@livechat/widget-core';
import { apiConfig } from '@bonanza-social/toolkit/api';
import {
  appOpened,
  startListening,
  socketConnected,
  isAnyOf,
} from '@bonanza-social/toolkit/state';
import { logInfo } from '@bonanza-social/toolkit/logging';
import {
  groupUpdated,
  maximizeChat,
  setVisibility,
  selectSessionFieldsTS,
  updateSessionVariables,
} from './chat.slice';
import { createChatWidget, shouldSetSessionVariables } from './chat.utils';
import { selectLiveChatGroupId } from '@bonanza-social/account/state';
import { switchLanguage } from '@bonanza-social/account/state';

export const WIDGET_LICENSE = '19774687';

let chatPromise: Promise<WidgetInstance>;

startListening({
  actionCreator: appOpened,
  effect: () => {
    chatPromise = createChatWidget(WIDGET_LICENSE, undefined);
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on('LiveChatGroupIdUpdated', (data) => {
      logInfo('[GenericHub] LiveChatGroupIdUpdated', data);

      // Reinitialize the chat with the new group id.
      dispatch(groupUpdated(data.groupId));
    });
  },
});

startListening({
  matcher: isAnyOf(switchLanguage, groupUpdated),
  effect: (action, { getState }) => {
    chatPromise.then((instance) => {
      const customerStatus = getData('customer').status;

      const isGroupUpdated = groupUpdated.match(action);
      const isLanguageSwitch = switchLanguage.match(action);

      const groupId = isGroupUpdated
        ? action.payload
        : selectLiveChatGroupId(getState());

      const language = isLanguageSwitch ? action.payload : undefined;

      if (customerStatus !== 'chatting') {
        instance.destroy();
        chatPromise = createChatWidget(WIDGET_LICENSE, groupId, language);
      }
    });
  },
});

startListening({
  actionCreator: setVisibility,
  effect: async ({ payload }, { dispatch, getState }) => {
    const userId = await apiConfig.getUserId();
    const sessionFieldsTS = selectSessionFieldsTS(getState());

    // There is no authenticated user.
    if (!userId || payload !== 'maximized') {
      return;
    }

    if (Number(userId) > 0 && shouldSetSessionVariables(sessionFieldsTS)) {
      dispatch(updateSessionVariables());
    }
  },
});

startListening({
  actionCreator: maximizeChat,
  effect: () => {
    chatPromise.then((instance) => instance.updateVisibility('maximized'));
  },
});
